import { APICallV1 } from 'reactApp/api/APICall';

export class RestoreAllTrashbinAPICall extends APICallV1 {
    _method = 'necromancer/restore_all';
    _type = 'post';
}
